// extracted by mini-css-extract-plugin
module.exports = {"input":"ModalCadastroProjeto_input__16xWw","linhaSalvar":"ModalCadastroProjeto_linhaSalvar__245wv","alerta":"ModalCadastroProjeto_alerta__2p5LT"};